// token.service.js
import { ref } from "vue";
import router from "@/router";

const readUserFromStorage = () => {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const currentUser = ref(readUserFromStorage());

const notifyAuthChange = (user) => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("auth-change", {
        detail: user,
      })
    );
  }
};

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === "user") {
      currentUser.value = readUserFromStorage();
      notifyAuthChange(currentUser.value);
    }
  });
}

class TokenService {
  // Vue Reactivity desteği için reaktif ref getter'ı
  get user() {
    return currentUser;
  }

  // ---- Okuma ----
  getUser() {
    if (currentUser.value === undefined) {
      currentUser.value = readUserFromStorage();
    }
    return currentUser.value;
  }

  getLocalAccessToken() {
    return this.getUser()?.accessToken?.token ?? "";
  }

  getLocalRefreshToken() {
    return this.getUser()?.refreshToken?.token ?? "";
  }

  getLocalClaims() {
    return this.getUser()?.claims ?? [];
  }

  // ---- Yazma ----
  setUser(user) {
    const userData = {
      accessToken: {
        token: user.accessToken.token,
        expiration: user.accessToken.expirationDate, // tek isim kullan
      },
      refreshToken: {
        token: user.refreshToken,
      },
      userId: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      isCoach: user.isCoach,
      claims: user.claims ?? [],
    };
    localStorage.setItem("user", JSON.stringify(userData));
    currentUser.value = userData;
    notifyAuthChange(userData);
  }

  updateLocalTokens(tokens) {
    const user = this.getUser();
    if (!user) return; // null guard

    user.accessToken.token = tokens.accessToken;
    user.refreshToken.token = tokens.refreshToken;

    localStorage.setItem("user", JSON.stringify(user));
    currentUser.value = { ...user };
    notifyAuthChange(currentUser.value);
  }

  // ---- Logout ----
  removeUser(options = { redirect: true }) {
    localStorage.removeItem("user");
    currentUser.value = null;
    notifyAuthChange(null);

    if (options?.redirect !== false) {
      const currentPath = router.currentRoute?.value?.path || "";
      if (currentPath !== "/") {
        router.replace("/").catch((err) => {
          console.warn("[TokenService] Navigation error on logout:", err);
        });
      }
    }
  }

  // Eski API'yi bozmamak için alias'lar
  logout(options) {
    this.removeUser(options);
  }

  logOutUser(options) {
    this.removeUser(options);
  }
}

export default new TokenService();
